import AssessmentIcon from "@mui/icons-material/Assessment";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import PhoneInTalk from "@mui/icons-material/PhoneInTalk";
import CampaignIcon from "@mui/icons-material/Campaign";
import { createSvgIcon } from '@mui/material/utils';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
export const ROLES = {
  SUPER: "SUPER_ADMIN",
  ADMIN: "ADMINISTRADOR",
  BUSINESS_ADMIN: "ADMINISTRADOR DE EMPRESAS",
  CLIENT: "CONTACTO",
  EXT:"EXTERNO"
};

const TicketIcon = createSvgIcon(
  <path d="M12.0863 9.97462e-05H9.6839C9.6839 9.97462e-05 9.26427 2.5176 6.48076 2.63151C3.67801 2.49836 3.27814 9.97462e-05 3.27814 9.97462e-05H0.87578C0.760213 -0.00165802 0.645471 0.0198324 0.538369 0.0632948C0.431266 0.106757 0.333986 0.171305 0.252307 0.253105C0.170628 0.334906 0.106214 0.432291 0.0628915 0.539477C0.0195692 0.646664 -0.00177852 0.761465 0.000115894 0.877065V5.72118H0.953779C1.02439 5.71931 1.09464 5.73186 1.16025 5.75805C1.22585 5.78425 1.28544 5.82353 1.33536 5.87352C1.38529 5.92351 1.4245 5.98315 1.45063 6.0488C1.47675 6.11445 1.48922 6.18473 1.48729 6.25537C1.48915 6.32596 1.47662 6.39618 1.45047 6.46177C1.42431 6.52736 1.38509 6.58694 1.33517 6.63687C1.28525 6.6868 1.22569 6.72604 1.16012 6.7522C1.09456 6.77836 1.02435 6.7909 0.953779 6.78904H0.000115894V11.9385L0.0193553 11.9577L0.0385955 22.1229C0.0366974 22.2386 0.0580774 22.3535 0.101464 22.4608C0.14485 22.568 0.209357 22.6654 0.291148 22.7473C0.372938 22.8291 0.470343 22.8936 0.577567 22.937C0.684791 22.9804 0.799646 23.0018 0.9153 22.9999H3.31766C3.31766 22.9999 3.73729 20.4824 6.5208 20.3685C9.32303 20.5016 9.72342 22.9999 9.72342 22.9999H12.1258C12.2412 23.0014 12.3558 22.9798 12.4627 22.9362C12.5696 22.8927 12.6667 22.8281 12.7482 22.7463C12.8297 22.6645 12.894 22.5672 12.9372 22.4601C12.9805 22.3531 13.0018 22.2384 12.9999 22.1229V11.0615L12.9806 11.0428V6.8088H12.2943C12.1556 6.80447 12.024 6.74632 11.9275 6.64666C11.8309 6.547 11.7769 6.41366 11.7769 6.27487C11.7769 6.13608 11.8309 6.00274 11.9275 5.90308C12.024 5.80342 12.1556 5.74527 12.2943 5.74094H12.9806V0.89683C12.9808 0.779075 12.9577 0.662449 12.9127 0.553625C12.8678 0.444801 12.8018 0.345914 12.7186 0.262625C12.6353 0.179335 12.5365 0.113277 12.4278 0.0682299C12.319 0.0231829 12.2024 3.1284e-05 12.0847 9.97462e-05H12.0863ZM4.74607 6.27409C4.74801 6.34477 4.73552 6.4151 4.70936 6.48078C4.68321 6.54647 4.64394 6.60613 4.59396 6.65613C4.54398 6.70612 4.48434 6.7454 4.41867 6.77156C4.35301 6.79772 4.2827 6.81022 4.21204 6.80828H2.57251C2.43088 6.80828 2.29504 6.752 2.19489 6.65182C2.09474 6.55164 2.03848 6.41577 2.03848 6.27409C2.03848 6.13242 2.09474 5.99654 2.19489 5.89636C2.29504 5.79618 2.43088 5.7399 2.57251 5.7399H4.17408C4.24741 5.73436 4.32108 5.74409 4.39046 5.76847C4.45984 5.79286 4.52341 5.83136 4.57715 5.88156C4.6309 5.93176 4.67367 5.99256 4.70274 6.06012C4.73181 6.12768 4.74657 6.20054 4.74607 6.27409ZM7.97001 6.25537C7.97188 6.326 7.95933 6.39627 7.93315 6.4619C7.90696 6.52752 7.86769 6.58712 7.81771 6.63706C7.76774 6.687 7.70812 6.72623 7.64249 6.75236C7.57686 6.77849 7.50659 6.79097 7.43598 6.78904H5.83441C5.76292 6.79127 5.6917 6.77911 5.62499 6.75328C5.55828 6.72745 5.49744 6.68848 5.44607 6.63868C5.39471 6.58888 5.35387 6.52927 5.32598 6.46338C5.29809 6.39748 5.28372 6.32666 5.28372 6.25511C5.28372 6.18355 5.29809 6.11273 5.32598 6.04684C5.35387 5.98095 5.39471 5.92133 5.44607 5.87153C5.49744 5.82173 5.55828 5.78276 5.62499 5.75693C5.6917 5.7311 5.76292 5.71894 5.83441 5.72118H7.43598C7.7407 5.72118 7.98873 5.96877 7.96949 6.25537H7.97001ZM11.2111 6.25537C11.213 6.32596 11.2004 6.39618 11.1743 6.46177C11.1481 6.52736 11.1089 6.58694 11.059 6.63687C11.0091 6.6868 10.9495 6.72604 10.884 6.7522C10.8184 6.77836 10.7482 6.7909 10.6776 6.78904L9.0568 6.80828C8.91516 6.80828 8.77933 6.752 8.67918 6.65182C8.57903 6.55164 8.52276 6.41577 8.52276 6.27409C8.52276 6.13242 8.57903 5.99654 8.67918 5.89636C8.77933 5.79618 8.91516 5.7399 9.0568 5.7399H10.6584C10.7992 5.73794 10.9353 5.79047 11.0383 5.88652C11.1413 5.98258 11.2032 6.11473 11.2111 6.25537Z"/>,
  'ticket_icon'
);


const BusinessIcon = createSvgIcon(
  <path d="M0 0V23.1429H7.71429V18.6429H10.2857V23.1429H18V0H0ZM2.57143 2.57143H5.14286V5.14286H2.57143V2.57143ZM7.71429 2.57143H10.2857V5.14286H7.71429V2.57143ZM12.8571 2.57143H15.4286V5.14286H12.8571V2.57143ZM2.57143 7.71428H5.14286V10.2857H2.57143V7.71428ZM7.71429 7.71428H10.2857V10.2857H7.71429V7.71428ZM12.8571 7.71428H15.4286V10.2857H12.8571V7.71428ZM2.57143 12.8571H5.14286V15.4286H2.57143V12.8571ZM7.71429 12.8571H10.2857V15.4286H7.71429V12.8571ZM12.8571 12.8571H15.4286V15.4286H12.8571V12.8571ZM2.57143 18H5.14286V20.5714H2.57143V18ZM12.8571 18H15.4286V20.5714H12.8571V18Z"/>,
  'business_icon'
);

export const DuplicatesIcon = createSvgIcon(
  <svg
  width="100%"
  height="100%"
  viewBox="0 0 7 7"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.2"
      y="1.60039"
      width="5.2"
      height="5.2"
      rx="1.8"
      stroke="#4E5589"
      strokeWidth="0.4"
    />
    <rect
      x="1.60039"
      y="0.2"
      width="5.2"
      height="5.2"
      rx="1.8"
      fill="#E5E3E3"
      stroke="#4E5589"
      strokeWidth="0.4"
    />
    <path
      d="M5.7998 1.39922C5.7998 1.28876 5.71026 1.19922 5.5998 1.19922L3.7998 1.19922C3.68935 1.19922 3.5998 1.28876 3.5998 1.39922C3.5998 1.50968 3.68935 1.59922 3.7998 1.59922L5.3998 1.59922L5.3998 3.19922C5.3998 3.30968 5.48935 3.39922 5.5998 3.39922C5.71026 3.39922 5.7998 3.30968 5.7998 3.19922L5.7998 1.39922ZM2.94123 4.34064L5.74123 1.54064L5.45838 1.2578L2.65838 4.0578L2.94123 4.34064Z"
      fill="#4E5589"
    />
  </svg>,
  "duplicates_icon"
);

const RatesIcon = createSvgIcon(
  <path d="M11.1 19H12.85V17.75C13.6833 17.6 14.4 17.275 15 16.775C15.6 16.275 15.9 15.5333 15.9 14.55C15.9 13.85 15.7 13.2083 15.3 12.625C14.9 12.0417 14.1 11.5333 12.9 11.1C11.9 10.7667 11.2083 10.475 10.825 10.225C10.4417 9.975 10.25 9.63333 10.25 9.2C10.25 8.76667 10.4042 8.425 10.7125 8.175C11.0208 7.925 11.4667 7.8 12.05 7.8C12.5833 7.8 13 7.92917 13.3 8.1875C13.6 8.44583 13.8167 8.76667 13.95 9.15L15.55 8.5C15.3667 7.91667 15.0292 7.40833 14.5375 6.975C14.0458 6.54167 13.5 6.3 12.9 6.25V5H11.15V6.25C10.3167 6.43333 9.66667 6.8 9.2 7.35C8.73333 7.9 8.5 8.51667 8.5 9.2C8.5 9.98333 8.72917 10.6167 9.1875 11.1C9.64583 11.5833 10.3667 12 11.35 12.35C12.4 12.7333 13.1292 13.075 13.5375 13.375C13.9458 13.675 14.15 14.0667 14.15 14.55C14.15 15.1 13.9542 15.5042 13.5625 15.7625C13.1708 16.0208 12.7 16.15 12.15 16.15C11.6 16.15 11.1125 15.9792 10.6875 15.6375C10.2625 15.2958 9.95 14.7833 9.75 14.1L8.1 14.75C8.33333 15.55 8.69583 16.1958 9.1875 16.6875C9.67917 17.1792 10.3167 17.5167 11.1 17.7V19ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z" />,
  'rates_icon'
);


export let SECTIONS = [
  {
    name: "Home",
    shortLabel:'Home',
    icon: <HomeOutlinedIcon  />,
    link: "home",
    alert: false,
    roles: [ROLES.SUPER, ROLES.ADMIN,ROLES.CLIENT,ROLES.EXT, ROLES.BUSINESS_ADMIN],
  },
  {
    name: "Ticket",
    shortLabel:'Ticket',
    icon: <TicketIcon  />,
    link: "tickets",
    alert: false,
    roles: [ROLES.SUPER, ROLES.ADMIN, ROLES.BUSINESS_ADMIN],
  },
  {
    name: "Campaña",
    shortLabel:'Campaña',
    icon: <CampaignIcon />,
    link: "campaigns",
    alert: false,
    roles: [ROLES.SUPER, ROLES.ADMIN,ROLES.CLIENT, ROLES.BUSINESS_ADMIN],
  },
  {
    name: "Empresa",
    shortLabel:'Empresa',
    icon: <BusinessIcon />,
    link: "business",
    alert: false,
    roles: [ROLES.SUPER, ROLES.ADMIN],
  },
  {
    name: "Usuario",
    shortLabel:'Usuario',
    icon: <PeopleAltIcon />,
    link: "users",
    alert: false,
    roles: [ROLES.SUPER, ROLES.ADMIN],
  },
  {
    name: "Números Cortos",
    shortLabel:'Nro. Cortos',
    icon: <PhoneInTalk />,
    link: "shortcodes",
    alert: false,
    roles: [ROLES.SUPER, ROLES.ADMIN],
  },
  {
    name: "Estadísticas",
    shortLabel:'Estadísticas',
    icon: <AssessmentIcon />, 
    link: "dashboard",
    alert: false,
    roles: [ROLES.SUPER, ROLES.ADMIN, ROLES.EXT,ROLES.CLIENT, ROLES.BUSINESS_ADMIN],
  },
  {
    name: "Campaña",
    shortLabel:'Campaña',
    icon: <CampaignIcon />,
    link: "campaigns",
    alert: false,
    roles: [ROLES.EXT],
  },
  {
    name: "Tarifas",
    shortLabel:'Tarifas',
    icon: <RatesIcon />,
    link: "rates",
    alert: false,
    roles: [ROLES.SUPER],
  },
  {
    name: "Tarifas",
    shortLabel:'Tarifas',
    icon: <RatesIcon />,
    link: "rates-contact",
    alert: false,
    roles: [ROLES.CLIENT, ROLES.BUSINESS_ADMIN],
  },
];
